
    export default {
     "normalData":[
        {"x": "Department Stores1", "value": 737166},
        {"x": "Discount Stores", "value": 537166},
        {"x": "Specialty Stores", "value": 188662},
        {"x": "Juvenile Specialty Stores", "value": 178662},
        {"x": "All other outlets", "value": 89000}
    ],
    "bubbleData":[
                [1, 637, 6],
                [2, 472, 14],
                [3, 48, 10]
            ],

              // all data
    "bubble1":[
        {"x": 2000, value: 1200, size: 3},
        {"x": 2001, value: 800, size: 3},
        {"x": 2002, value: 1100, size: 3},
        {"x": 2003, value: 1500, size: 2},
        {"x": 2004, value: 921, size: 4},
        {"x": 2005, value: 1000, size: 3},
        {"x": 2006, value: 1400, size: 2}
    ],
    "bubble2":[
        {"x": 2000, value: 900, size: 1},
        {"x": 2001, value: 950, size: 4},
        {"x": 2002, value: 800, size: 2},
        {"x": 2003, value: 1000, size: 3},
        {"x": 2004, value: 800, size: 3},
        {"x": 2005, value: 750, size: 1},
        {"x": 2006, value: 800, size: 2}
    ],
    "heatMapData":[
    {"x": "Quarter 1", "y": "Mobile", "heat": 15},
    {"x": "Quarter 2", "y": "Mobile", "heat": 17},
    {"x": "Quarter 3", "y": "Mobile", "heat": 21},
    {"x": "Quarter 4", "y": "Mobile", "heat": 23},
    {"x": "Quarter 1", "y": "WebMail", "heat": 34},
    {"x": "Quarter 2", "y": "WebMail", "heat": 33},
    {"x": "Quarter 3", "y": "WebMail", "heat": 32},
    {"x": "Quarter 4", "y": "WebMail", "heat": 30},
    {"x": "Quarter 1", "y": "Desktop", "heat": 43},
    {"x": "Quarter 2", "y": "Desktop", "heat": 42},
    {"x": "Quarter 3", "y": "Desktop", "heat": 40},
    {"x": "Quarter 4", "y": "Desktop", "heat": 38},
    {"x": "Quarter 1", "y": "Undetected", "heat": 8},
    {"x": "Quarter 2", "y": "Undetected", "heat": 8},
    {"x": "Quarter 3", "y": "Undetected", "heat": 7},
    {"x": "Quarter 4", "y": "Undetected", "heat": 8}
  ],
  "markerData":[
    ["2000", 1100],
    ["2001", 880],
    ["2002", 1100],
    ["2003", 1500],
    ["2004", 921],
    ["2005", 1000],
    ["2006", 1400]
    ],
    "rangeData":[
    ["January", 0.7, 6.1],
    ["February", 0.6, 6.3],
    ["March", 1.9, 8.5],
    ["April", 3.1, 10.8],
    ["May", 5.7, 14.4]
    ],
    "stackedData":[
        ["QTR1", 3.8, 5.5, 6.9],
        ["QTR2", 5.5, 7.0, 9.6],
        ["QTR3", 9.9, 9.7, 8.3],
        ["QTR4", 5.7, 7.6, 9.7]
    ],

 }



// WEBPACK FOOTER //
// ./static/data.js